import React, { useEffect, useMemo, useState } from 'react'
import commonStyles from "../ManageForms.styles"
import Accordion from '../../../../components/accordion/Accordion'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown'
import Button from '../../../../components/button/Button'
import TextInput from '../../../../components/input/textinput/TextInput'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import RichGrid from '../../../../components/richgrid/RichGrid'
import { LABEL_WEIGHT } from '../../../../components/label/constants'
import Label from '../../../../components/label/Label'
import CheckboxWLabel from '../../../../components/checkbox/checkboxwlabel/CheckboxWLabel'
import Checkbox from '../../../../components/checkbox/basecheckbox/Checkbox'
import { componentKey, setBlockSubmissionModal, setDownloadMultiplePDFModal, setDownloadPDFsByReferenceModal, setDownloadPDFsForSelectedPayerModal, setExportToExcelForAllPayers, setExportToExcelForSelectedPayersModal, setExportToExcelModal, setPaginationState, setSendPayerCopyEmailModal, setEDeliveryModalOpen, setUspsMailToRecipientsModal, setEmailRecipientCopyModal, setSelectedFederalStates, toggle, setSelectedFederalForms, setStateFilingCheckBox, setStateFilingSelectAllCheckbox, setSelectedFederal91xForms, setExportToExcelSelectedForm, setSelectedPayers, setDownloadPdfSelectedSelectedStates, setDownloadPdfType, setSelectMultiplePayers, setDownload94xMultiplePdfModal, setBlockFederalFormModal, setFederalFormData, setChangeScheduleDate, setBlockSubmissionSelectedReference, setStateFilingModal, setSendPayerCopyByEmail94xModal, setPaginationState94x, setBulkStateFilingModal, setDownloadSingleRowPDFModal, setDownloadPdfCheckboxStates, setReloadGridData, setPayerDropdownPagination } from './ManageFederalFormsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants'
import SendPayerCopyByEmailModal from './sendpayercopybyemail/SendPayerCopyByEmailModal'
import DownloadPdf from './downloadpdf/DownloadPdf'
import BlockSubmission from './blocksubmission/BlockSubmission'
import ExportToExcel from './exporttoexcel/ExportToExcel'
import USPSMailToRecipients from './uspsmailtorecipients/USPSMailToRecipients'
import EmailRecipientCopy from './emailrecipientcopy/EmailRecipientCopy'
import { blockFederalSubmission, changeScheduleData, downLoad94xPDFs, downloadFedMultiplePDFs, downloadFedPDFsByPayers, downloadFedPDFsByReference, emailToRecipient, get94xGridData, get94xTaxYears, getFederalExport, getFederalExportForAllPayers, getFederalExportForSelectedPayer, getFederalGridData, getFederalPDF, view94xPDF, sendPayerCopyInMail, getStateForms } from './ManageFederalFormsSaga'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import Payer from '../../../../../libs/utility/Payer'
import { componentKey as manageFormsComponentKey, setManageFormsLoad, setViewTin } from "../ManageFormsSlice"
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import ChangeScheduleDateModal from '../../formslisting/changescheduledate/ChangeScheduleDateModal'
import { StateFiling } from './statefiling/StateFiling'
import General from '../../../../../libs/utility/General'
import { BulkStateFiling } from './bulkstatefiling/BulkStateFiling'
import Loadable from '../../../../components/loadable/Loadable'
import Icons from '../../../../components/icons/Icons'
import EDeliveryModal from './edeliverymodal/EDeliveryModal'
import Forms from '../../../../../libs/utility/formsutility/Forms'
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'
import { setShowPaymentNotAllowedPopup, componentKey as dashboardComponentKey } from '../../../dashboard/DashboardSlice'
import { isAccessAllowed, useUserPermissionsInfo } from '../../../dashboard/hooks/userHooks'
import { PAGE_PERMISSIONS } from '../../../dashboard/constants/constant'
import { EDIT_FORM_ORIGIN, FORM_SECTION_ROUTES, VIEW_TIN_CHECKBOX_MESSAGE } from '../../constants'
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook'
import { DOWNLOAD_PDF_COPY_OPTIONS, EXPORT_EXCEL_FIELDS, FIELDS_TEXTS, MANAGE_FEDERAL_FORMS_LOADING_STATES, MANAGE_FEDERAL_FORMS_LOADING_STATES_MESSAGE_MAP, MANAGE_FEDERAL_FORMS_STATE_FIELDS, MANAGE_FORMS_LOADING_STATES, MANAGE_FORMS_MESSAGE_MAP } from '../constants'
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook'
import IconDropdown from '../../../../components/dropdown/icondropdown/IconDropdown'
import InformationPopup from '../../../../components/popup/informationpopup/InformationPopup'
import { exportToExcel } from 'react-easy-export';
import useFormatTIN from '../../../../../libs/customhooks/useFormatTIN'
import { TOASTER_VARIANT } from '../../../../components/toast/constants'
import useDelayedAction from '../../../../../libs/customhooks/useDelayedAction'

const ManageFederalForms = ({ federalTaxYear, federalPayers }) => {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const navigate = useTxNavigate();
    const { permissions } = useUserPermissionsInfo();

    const { formatTIN } = useFormatTIN()

    const { globalFormsNYearsList } = useSelector(state => state[dataLoaderKey]);

    const { loadingState, paginationState, paginationState94x, federalGridForms, accordionOpen, sendPayerCopyByEmailModal, downloadMultiplePDFModal, downloadPDFsForSelectedPayerModal, downloadPDFsByReferenceModal, blockSubmissionModal, eDeliveryModal, exportToExcelForSelectedPayersModal, exportToExcelModal, exportToExcelForAllPayers, uspsMailToRecipientsModal, emailRecipientCopyModal, federalStates, selectedFederalForms, federal94xTaxYear, federal94XGridForms, selectedFederal91xForms, exportToExcelStates, selectedPayers, downloadPdfStates, downloadPdfType, multipleSelectedPayer, referenceNumber, download94xMultiplePdfModal, blockFederalFormModal, federalFormData, changeScheduleDateForAllVendor, blockSubmissionSelectedReference, stateFilingModal, sendPayerCopyByEmail94xModal, bulkStateFilingModal, stateForms, downloadSingleRowPDFModal, downloadPdfCheckboxStates, reloadGridData, payerDropdownPagination } = useSelector(state => state[componentKey])

    const { federalForms, manageFormsLoad, federalPayersLoader, isTINHidden } = useSelector(state => state[manageFormsComponentKey]);

    const { IsTinUnmaskAllowed } = useSelector(state => state[dashboardComponentKey])
    const [isSelectedFormsOfPastDate, setIsSelectedFormsOfPastDate] = useState(false)
    const [warningPopupMessage, setWarningPopupMessage] = useState("")
    const [selectedCopy, setSelectedCopy] = useState(DOWNLOAD_PDF_COPY_OPTIONS.find(option => option.value === 'payer' || option.value === 'payee') || DOWNLOAD_PDF_COPY_OPTIONS[0])
    const [paginatedPayerList, setPaginatedPayerList] = useState([]);

    useEffect(() => {
        setPaginatedPayerList(federalPayers)
    }, [federalPayers])

    useEffect(() => {
        const urlFilterText = queryParams.get("FilterText");
        const urlCategory = queryParams.get("Category");

        if (urlFilterText) {
            dispatch(setPaginationState({ FilterText: urlFilterText }));
        }

        if (urlCategory) {
            if (urlCategory === "1099") {
                dispatch(toggle(true))
            } else if (urlCategory === "944x") {
                dispatch(toggle(false))
            }
        }

        dispatch(get94xTaxYears());

    }, []);

    useEffect(() => {
        dispatch(getStateForms())
    }, [])

    useEffect(() => {
        const urlTaxYear = queryParams.get("TaxYear");
        const urlCategory = queryParams.get("Category");

        if (urlTaxYear) {
            const taxYear = (urlCategory && urlCategory === "944x") ? federal94xTaxYear.find(year => year?.value == urlTaxYear) : federalTaxYear.find(year => year?.value == urlTaxYear);
            
            const name = urlCategory && urlCategory === "944x" ? "FederalTaxYear2" : "FederalTaxYear"
            if (taxYear) {
                dispatch(setSelectedFederalStates({ name: name, value: taxYear }))
            }
        }

    }, [federalTaxYear, federal94xTaxYear]);

    useEffect(() => {
        if (federalPayers.length) {
            const urlPayerId = queryParams.get("PayerId");
            const urlCategory = queryParams.get("Category");

            if (urlPayerId) {
                const payer = federalPayers.find(payer => payer?.value == urlPayerId);
                if (payer) {
                    const name = urlCategory && urlCategory === "944x" ? "FederalPayer2" : "FederalPayer"
                    dispatch(setSelectedFederalStates({ name: name, value: payer }))
                }
            }
        }
    }, [federalPayers]);

    useEffect(() => {
        const accordionTab = accordionOpen ? "1099" : "944x";

        if (accordionOpen) {
            if (federalPayers?.length) {
                queryParams.set("PayerId", federalStates?.FederalPayer?.value);
                if(federalStates?.FederalTaxYear?.value){
                    queryParams.set("TaxYear", federalStates?.FederalTaxYear?.value);
                }
                queryParams.set("FilterText", paginationState?.FilterText);
            }
        } else if (federal94XGridForms?.length) {
            queryParams.set("PayerId", federalStates?.FederalPayer2?.value);
            queryParams.set("TaxYear", federalStates?.FederalTaxYear2?.value);
            queryParams.delete("FilterText");
        
        }

        queryParams.set("Category", accordionTab);
        setQueryParams(queryParams);

    }, [accordionOpen])

    useEffect(() => {
        if (federalStates.FederalPayer.value.length !== 0 && federalStates.FederalTaxYear.value.length !== 0) {
            handleGetRecords();
        }
    }, [federalStates.FederalPayer, federalStates.FederalTaxYear, paginationState.FilterText, paginationState.PageNumber, paginationState.PageSize, paginationState.IsDesc, paginationState.Page])

    useEffect(() => {
        if (reloadGridData) {
            handleGetRecords();
            dispatch(setReloadGridData(false));
        }
    }, [reloadGridData])

    const handleGetRecords = useDelayedAction(() => {
        if (federalStates.FederalPayer.value.length !== 0 && federalStates.FederalTaxYear.value.length !== 0) {
            dispatch(getFederalGridData({
                payerId: federalStates.FederalPayer.value,
                taxYear: federalStates.FederalTaxYear.value,
                FilterText: paginationState.FilterText,
                PageNumber: paginationState.PageNumber,
                PageSize: paginationState.PageSize,
                IsDesc: paginationState.IsDesc,
                Page: paginationState.Page
            }));
        } else {
            dispatch(addNotifications({ heading: "Error", message: "Please select payer and tax year to continue" }));
        }
    });

    useEffect(() => {
        if (federalStates.FederalPayer2.value.length !== 0 && federalStates.FederalTaxYear2.value.length !== 0) {
            dispatch(get94xGridData({ payerId: federalStates.FederalPayer2.value, taxYear: federalStates.FederalTaxYear2.value, PageNumber: paginationState94x.PageNumber, PageSize: paginationState94x.PageSize }))
        }
    }, [federalStates.FederalPayer2, federalStates.FederalTaxYear2, paginationState94x.PageNumber, paginationState94x.PageSize])

    function mergeObjectsByFormName(arr) {
        const mergedArray = [];
        const formNamesMap = new Map();

        arr.forEach((obj) => {
            const formName = obj.FormName;
            if (!formNamesMap.has(formName)) {
                formNamesMap.set(formName, { value: obj.FormId, label: obj.FormName, FormId: obj.FormId });
            } else {
                const existingObj = formNamesMap.get(formName);
                formNamesMap.set(formName, { ...existingObj, ...{ value: obj.FormId, label: obj.FormName, FormId: obj.FormId } });
            }
        });

        formNamesMap.forEach((mergedObj) => {
            mergedArray.push(mergedObj);
        });

        return mergedArray;
    }

    useEffect(() => {
        if (!selectedFederalForms.length) {
            return setIsSelectedFormsOfPastDate(false)
        }

        let isFutureDateFormExists = true;

        selectedFederalForms.forEach((form) => {
            if (!General.isDateInPast(form?.ScheduleDateString)) {
                return isFutureDateFormExists = false
            }
        })

        setIsSelectedFormsOfPastDate(isFutureDateFormExists)
    }, [selectedFederalForms])

    const onDownloadErrorsClick = () => {
        const sheetErrors = selectedFederalForms.map(payeeInfo => {
            if (!payeeInfo?.TIN && !payeeInfo?.emailId) {
                return [payeeInfo.PayeeName, EXPORT_EXCEL_FIELDS.MISSING_TIN_AND_EMAIL_TEXT]
            } else if (!payeeInfo?.TIN) {
                return [payeeInfo.PayeeName, EXPORT_EXCEL_FIELDS.MISSING_TIN_TEXT]
            } else if (!payeeInfo?.emailId) {
                return [payeeInfo.PayeeName, EXPORT_EXCEL_FIELDS.MISSING_EMAIL_TEXT]
            } else {
                return []
            }
        })
        const excelData = [EXPORT_EXCEL_FIELDS.SHEET_HEADINGS, ...sheetErrors]

        exportToExcel(excelData, EXPORT_EXCEL_FIELDS.FILE_NAME);
    }

    const MANAGE_FEDERAL_FORM_COLUMN_1 = [
        {
            field: "ReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>Reference No.</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row.ReferenceNumber}</span>
        },
        {
            field: "RecipientName",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.PayeeName}</span>
        },
        {
            field: "TaxId",
            header: <Label weight={LABEL_WEIGHT[700]}>Tax ID</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{Payer.getPayerTINByIdType(row?.TINType, row?.TIN, isTINHidden)}</span>
        },
        {
            field: "FormName",
            header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.FormName}</span>
        },
        {
            field: "Status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.Status}</span>
        },
        {
            field: "ConsentStatus",
            header: <Label weight={LABEL_WEIGHT[700]}>Consent Status</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{Forms.getConsentStatusFromID(row?.OptIn)}</span>
        },
        {
            field: "USPS",
            header: <Label weight={LABEL_WEIGHT[700]}>USPS</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.USPSRequested || "-"}</span>
        },
        {
            field: "Email",
            header: <Label weight={LABEL_WEIGHT[700]}>Email</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.emailId || "-"}</span>
        },
        {
            field: "stateFiling",
            header: <CheckboxWLabel
                name='IsState'
                label="State Filing"
                weight={LABEL_WEIGHT[700]}
                checked={federalGridForms.every(item => item.IsState)}
                onChangeCb={() => dispatch(setBulkStateFilingModal(true))}
            />,
            renderLogic: (row, idx) => <span style={commonStyles.flexColumnWithGap}>
                {
                    MANAGE_FEDERAL_FORMS_STATE_FIELDS.map((property, index) => (
                        row[`${property.state}`] && (
                            <CheckboxWLabel
                                key={`checkbox-${property.state}-${index}`}
                                label={row[property.state]}
                                disabled={row[`${property.state}disable`] === "disable" || General.isDateInPast(row?.ScheduleDateString)}
                                name='IsState'
                                checked={row[`State${property.filing}Completed`] == "true"}
                                onChangeCb={(event) => dispatch(setStateFilingCheckBox({ checked: event.target.checked, index: idx, checkBoxProperty: `State${property.filing}Completed` }))}
                            />
                        )
                    ))
                }
            </span>
        },
        {
            field: "StateOnly",
            header: <Label weight={LABEL_WEIGHT[700]}>State Only</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.seperateStateFiling || "-"}</span>
        },
        {
            field: "SubmittedDate",
            header: <Label weight={LABEL_WEIGHT[700]}>Submitted Date</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.SubmittedDateString || "-"}</span>
        },
        {
            field: "ScheduleDate",
            header: <Label weight={LABEL_WEIGHT[700]}>Schedule Date</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.ScheduleDateString || "-"}</span>
        },
        {
            field: "operations",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Operations</Label >,
            renderLogic: (row, idx) => {
                const isPastDate = General.isDateInPast(row?.ScheduleDateString)

                const MENU_OPTIONS = [
                    {
                        itemName: "View PDF",
                        onClick: () => {
                            dispatch(setFederalFormData(row))
                            dispatch(setDownloadSingleRowPDFModal(true));
                        },
                        styles: commonStyles.prmiaryText,
                    },
                    {
                        itemName: "Edit",
                        onClick: !isPastDate && (() => {
                            const queryObj = {
                                FormName: globalFormsNYearsList.Forms[row?.FormTypeId].FormId,
                                Year: federalStates?.FederalTaxYear?.value,
                                FormRecordId: row?.FormId,
                                page: "ManageForms",
                                metaData: JSON.stringify({
                                    [EDIT_FORM_ORIGIN]: FORM_SECTION_ROUTES.FEDERALFORMS,
                                })
                            }
                            const queryParamsStr = General.convertObjToQueryString(queryObj)

                            navigate(`/forms/createnew?${queryParamsStr}`)
                        }),
                        styles: isPastDate ? commonStyles.disabledMenuItem : commonStyles.prmiaryText,
                    },
                    {
                        itemName: "Block",
                        onClick: !isPastDate && (() => {
                            dispatch(setBlockFederalFormModal(true))
                            dispatch(setFederalFormData(row))
                        }),
                        styles: isPastDate ? commonStyles.disabledMenuItem : commonStyles.prmiaryText,
                    },
                ]


                return <div style={commonStyles.actionButtons}>
                    <IconDropdown
                        iconName={VEC_ICON_NAME.THREE_DOT_MENU_ICON}
                        showToggle={false}
                        label=""
                        dropdownItems={MENU_OPTIONS}
                        dropdownMenuStyle={commonStyles.menuItemsDropdown}
                    />
                </div>
            }
        },
    ];

    const MANAGE_FEDERAL_FORM_COLUMN_2 = [
        {
            field: "ReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>Reference No.</Label>,
            renderLogic: (row, idx) => <span style={{ ...commonStyles.text, ...commonStyles.date }}>{row.ReferenceNumber}</span>
        },
        {
            field: "EIN",
            header: <Label weight={LABEL_WEIGHT[700]}>EIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row.TINType, row.EIN) || "-"}</span>
        },
        {
            field: "FormName",
            header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.FormName || "-"}</span>
        },
        {
            field: "Status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.Status || "-"}</span>
        },
        {
            field: "SubmissionDate",
            header: <Label weight={LABEL_WEIGHT[700]}>Submission Date</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.SubmissionDate || "-"}</span>
        },
        {
            field: "Quarter",
            header: <Label weight={LABEL_WEIGHT[700]}>Quarter</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row.Quarter || "-"}</span>
        },
        {
            field: "action",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Action</Label >,
            renderLogic: (row, idx) => {
                const ACTIONS_MENU_OPTIONS = [
                    {
                        itemName: "View PDF",
                        onClick: () => {
                            dispatch(view94xPDF({ payerId: federalStates.FederalPayer2.value, formId: row.FormId, formTypeId: row.FormTypeId }))
                        },
                        styles: commonStyles.prmiaryText,
                    },
                    !globalFormsNYearsList.Forms[row?.FormTypeId].FormId.includes("Form941") && {
                        itemName: "Edit",
                        onClick: () => {
                            const queryObj = {
                                FormName: globalFormsNYearsList.Forms[row?.FormTypeId].FormId,
                                Year: federalStates?.FederalTaxYear2?.value,
                                FormRecordId: row?.FormId,
                                metaData: JSON.stringify({
                                    [EDIT_FORM_ORIGIN]: FORM_SECTION_ROUTES.FEDERALFORMS,
                                })
                            }
                            const queryParamsStr = General.convertObjToQueryString(queryObj)

                            navigate(`/forms/createnew?${queryParamsStr}`)
                        },
                        styles: commonStyles.prmiaryText,
                    },
                ]

                return <div style={commonStyles.actionButtons}>
                    <IconDropdown
                        iconName={VEC_ICON_NAME.THREE_DOT_MENU_ICON}
                        showToggle={false}
                        label=""
                        dropdownItems={ACTIONS_MENU_OPTIONS}
                        dropdownMenuStyle={commonStyles.menuItemsDropdown}
                    />
                </div>
            }
        },
    ];

    const downloadPdfOptions = useMemo(() => {
        const set = new Set();

        const options = selectedFederalForms?.reduce((acc, current) => {
            if (!set.has(current?.FormTypeId)) {
                set.add(current?.FormTypeId);
                acc.push({
                    FormId: current?.FormTypeId,
                    FormName1: current?.FormName,
                    label: current?.FormName,
                    value: current?.FormTypeId
                });
            }
            return acc;
        }, []);

        return options;
    }, [selectedFederalForms]);

    const DRAWER_BULK_ACTION_BUTTONS = [
        {
            itemName: "Download Multiple PDF",
            onClick: () => {
                if (federalStates.FederalPayer.value.length !== 0 && federalStates.FederalTaxYear.value.length !== 0 && selectedFederalForms.length) {
                    dispatch(setDownloadMultiplePDFModal(true))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "Please select a form" }))
                }
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "USPS Mail to Recipient",
            onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    selectedFederalForms?.length ? dispatch(setUspsMailToRecipientsModal(true)) : dispatch(addNotifications({ heading: "Error", message: "Please select recipient to send mail", variant: TOASTER_VARIANT.WARNING }))
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "Export to Excel",
            onClick: () => {
                if (selectedFederalForms.length) {
                    dispatch(setExportToExcelModal(true))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "Please select a form" }))
                }
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "State Filling",
            onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    !selectedFederalForms?.length ? dispatch(addNotifications({ heading: "Error", message: "Please select a form" })) : dispatch(setStateFilingModal(true))
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "Change Schedule Date",
            onClick: () => {
                if (selectedFederalForms.length) {
                    dispatch(setChangeScheduleDate(true))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "Please select a form" }))
                }
            },
            styles: commonStyles.prmiaryText,
            styles: isSelectedFormsOfPastDate ? commonStyles.disabledMenuItem : commonStyles.prmiaryText,
        },
        {
            itemName: "eDelivery",
            onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    if (selectedFederalForms?.length) {
                        if (General.arrayObjectsKeyIsNotEmpty(selectedFederalForms, FIELDS_TEXTS.EMAIL_ID_TEXT) && General.arrayObjectsKeyIsNotEmpty(selectedFederalForms, FIELDS_TEXTS.TIN_TEXT)) {
                            dispatch(setEDeliveryModalOpen(true))
                        } else {
                            setWarningPopupMessage("Recipient without TIN and Email will not be processed for eDelivery request")
                        }
                    } else {
                        dispatch(addNotifications({ heading: "Error", message: "Please select recipient" }))
                    }
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
            },
            styles: commonStyles.prmiaryText,
        },
    ]

    const DRAWER_MORE_BUTTONS = [
        {
            itemName: "Export to Excel for Selected Payers",
            onClick: () => {
                if (federalStates.FederalTaxYear.value.length !== 0) {
                    dispatch(setExportToExcelForSelectedPayersModal(true))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "Please select tax year to continue" }))
                }
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "Block Submission",
            onClick: () => {
                dispatch(setBlockSubmissionModal(true))
            },
            styles: commonStyles.prmiaryText,
        },
    ]

    const DOWNLOAD_MORE_BUTTONS = [
        {
            itemName: "Download PDFs for Selected Payers",
            onClick: () => {
                if (federalStates.FederalTaxYear.value.length !== 0) {
                    dispatch(setExportToExcelForSelectedPayersModal(true))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "Please select tax year to continue" }))
                }
            },
            styles: commonStyles.prmiaryText,
        },
        {
            itemName: "Download PDFs by Reference",
            onClick: () => {
                if (federalStates.FederalPayer.value.length !== 0) {
                    dispatch(setDownloadPDFsByReferenceModal(true))
                } else {
                    dispatch(addNotifications({ heading: "Error", message: "Please select payer to continue" }))
                }
            },
            styles: commonStyles.prmiaryText,
        },
    ]

    const onChangeDownloadPdfCheckboxCb = (e) => {
        const { name, checked } = e.target
        dispatch(setDownloadPdfCheckboxStates({ [name]: checked }))
    }

    const Body1 = (
        <>
            <div>
                <div style={commonStyles.dropdownContainer}>
                    <div style={commonStyles.selectDropdown}>
                        <Loadable currentState={federalPayersLoader.state} loadingStates={[MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]} messageMap={MANAGE_FORMS_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
                            <SelectDropdown
                                label="Payer *"
                                name="FederalPayer"
                                placeHolder="Select a payer"
                                options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                                onDropdownTouchedToBottomCb={() => {
                                    if (payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length) {
                                        dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                                    }
                                }}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedFederalStates({ name: [name], value: selectedOption }));

                                    if (selectedOption?.value) {
                                        queryParams.set("PayerId", selectedOption?.value)
                                    } else {
                                        queryParams.delete("PayerId")
                                    }
                                    setQueryParams(queryParams);
                                    dispatch(setSelectedFederalForms([]));
                                    dispatch(setPaginationState({ Page: 1, Skip: 0, PageNumber: 1 }));
                                }}
                                value={federalStates.FederalPayer}
                            />
                        </Loadable>
                        <SelectDropdown
                            name="FederalTaxYear"
                            label="Tax Year *"
                            placeHolder="Select tax year"
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedFederalStates({ name: [name], value: selectedOption }));

                                if (selectedOption?.value) {
                                    queryParams.set("TaxYear", selectedOption?.value)
                                } else {
                                    queryParams.delete("TaxYear")
                                }
                                setQueryParams(queryParams);
                                dispatch(setSelectedFederalForms([]));
                                dispatch(setPaginationState({ Page: 1, Skip: 0, PageNumber: 1 }));
                            }}
                            options={federalTaxYear}
                            value={federalStates.FederalTaxYear}
                        />
                        {IsTinUnmaskAllowed ? <div>
                            <CheckboxWLabel
                                label={<span title={VIEW_TIN_CHECKBOX_MESSAGE} className='fs-16'>View TIN <span><Icons familyName={"vec"} iconName={VEC_ICON_NAME.INFO_ICON} /></span></span>}
                                checked={!isTINHidden}
                                onChangeCb={() => dispatch(setViewTin())}
                            />
                        </div> : null}
                    </div>
                    <div>
                        <TextInput
                            name="FilterText"
                            label='Search by Name'
                            placeHolder='Enter recipient name'
                            value={paginationState?.FilterText}
                            suffixProps={{
                                icon: VEC_ICON_NAME.SEARCH_ICON, suffixIconCb: () => {
                                    if (federalStates.FederalPayer.value.length !== 0 && federalStates.FederalTaxYear.value.length !== 0) {
                                        if (paginationState?.FilterText) {
                                            queryParams.set("FilterText", paginationState?.FilterText)
                                        } else {
                                            queryParams.delete("FilterText")
                                        }
                                        setQueryParams(queryParams);
                                        dispatch(getFederalGridData({ payerId: federalStates.FederalPayer.value, taxYear: federalStates.FederalTaxYear.value, FilterText: paginationState.FilterText, PageNumber: paginationState.PageNumber, PageSize: paginationState.PageSize, IsDesc: paginationState.IsDesc }));
                                    } else {
                                        dispatch(addNotifications({ heading: "Error", message: "Please select payer and tax year to continue" }))
                                    }
                                }
                            }
                            }
                            onChangeCb={event => { dispatch(setPaginationState({ FilterText: event.target.value, Page: 1, Skip: 0, })) }}
                        />
                    </div>
                </div>

                {federalStates?.FederalPayer?.value && federalStates?.FederalTaxYear?.value && <div style={commonStyles.buttonContainer}>
                    <div>
                        <IconDropdown
                            DropdownToggleComponent={<Icons iconName={VEC_ICON_NAME.CARET_DOWN} color="#ffffff" familyName="vec" />}
                            label="Bulk Actions"
                            dropdownItems={DRAWER_BULK_ACTION_BUTTONS}
                            dropdownContainerStyles={commonStyles.bulkActionDropdown}
                            styles={commonStyles.bulkActionDropdownLabel}
                            dropdownMenuStyle={commonStyles.bulkActionDropdownMenu}
                        />
                    </div>
                    <div>
                        <IconDropdown
                            DropdownToggleComponent={<Icons iconName={VEC_ICON_NAME.CARET_DOWN} color="#215DAA" familyName="vec" />}
                            label="Download PDFs"
                            dropdownItems={DOWNLOAD_MORE_BUTTONS}
                            dropdownContainerStyles={commonStyles.moreActionDropdown}
                            styles={commonStyles.moreActionDropdownLabel}
                            dropdownMenuStyle={commonStyles.moreActionDropdownMenu}
                        />
                    </div>

                    <div style={commonStyles.actionButtonContainer}>

                        <Button style={commonStyles.button} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => {

                            dispatch(setExportToExcelForAllPayers(true))

                        }}>Export to Excel for All Payers</Button>

                        {/* <Button style={commonStyles.button} onClickCb={() => selectedFederalForms?.length ? dispatch(setEmailRecipientCopyModal(true)) : dispatch(addNotifications({ heading: "Please select recipient to send mail" }))}>E-Mail Recipient Copy</Button> */}

                        <Button style={commonStyles.button} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => dispatch(setSendPayerCopyEmailModal(true))}>Send Payer Copy by Email</Button>
                        <div>
                            <IconDropdown
                                DropdownToggleComponent={<Icons iconName={VEC_ICON_NAME.CARET_DOWN} color="#215DAA" familyName="vec" />}
                                label="More"
                                dropdownItems={DRAWER_MORE_BUTTONS}
                                dropdownContainerStyles={commonStyles.moreActionDropdown}
                                styles={commonStyles.moreActionDropdownLabel}
                                dropdownMenuStyle={commonStyles.moreActionDropdownMenu}
                            />
                        </div>
                    </div>
                </div>
                }

                <Loadable currentState={loadingState.state} loadingStates={[MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING]} messageMap={MANAGE_FEDERAL_FORMS_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                    <div>
                        <RichGrid
                            selectable={true}
                            data={federalGridForms}
                            columns={MANAGE_FEDERAL_FORM_COLUMN_1}
                            extractRowKey={(row) => row.FormId}
                            selectedRows={selectedFederalForms}
                            onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedFederalForms(selectedData))}
                            onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedFederalForms(selectedData))}
                            paginationProps={{
                                skip: paginationState?.Skip,
                                take: paginationState?.PageSize,
                                takeOptions: ROW_SELECTION_OPTIONS,
                                total: paginationState?.Total,
                                onChangeTakeCb: (newTake) => {
                                    dispatch(setPaginationState({ PageSize: newTake, Page: 1, Skip: 0 }));
                                },
                                onChange: (take, skip) => {
                                    dispatch(setPaginationState({ PageSize: take, Skip: skip, Page: Math.ceil((take + skip) / take) }))
                                }
                            }}
                        />
                    </div>
                </Loadable>
            </div>

            {emailRecipientCopyModal &&
                <EmailRecipientCopy
                    isPopupOpen={emailRecipientCopyModal}
                    onCloseCb={() => dispatch(setEmailRecipientCopyModal(false))}
                    onSelectAllCb={() => dispatch(emailToRecipient({ formIds: federalGridForms.map(item => item.FormId).toString(), taxYear: federalStates.FederalTaxYear.value, formName: selectedFederalForms.map(item => item.FormName).toString(), payerId: federalStates.FederalPayer.value, AllSelected: true }))}
                    onSelectedOnlyCb={() => {
                        if (selectedFederalForms.length) {
                            dispatch(emailToRecipient({ formIds: selectedFederalForms.map(item => item.FormId).toString(), taxYear: federalStates.FederalTaxYear.value, formName: selectedFederalForms.map(item => item.FormName).toString(), payerId: federalStates.FederalPayer.value, AllSelected: true }))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select forms to continue" }))
                        }
                    }
                    }
                />
            }

            {blockSubmissionModal &&
                <BlockSubmission
                    isPopupOpen={blockSubmissionModal}
                    onCloseCb={() => dispatch(setBlockSubmissionModal(false))}
                    selectedReferenceNumber={blockSubmissionSelectedReference}
                    onSelectCb={(name, selectedOption) => dispatch(setBlockSubmissionSelectedReference(selectedOption))}
                    onSubmitCb={() => {
                        if (blockSubmissionSelectedReference?.value) {
                            dispatch(blockFederalSubmission({ referenceNumber: blockSubmissionSelectedReference?.value, State: blockSubmissionSelectedReference?.state1 || "", formId: null, formTypeId: null }))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select a reference number" }));
                        }
                    }}
                    options={referenceNumber.filter((form, index, self) => !General.isDateInPast(form?.ScheduleDateString) &&
                        self.findIndex(f => f.ReferenceNumber === form.ReferenceNumber) === index
                    )}
                />
            }

            {sendPayerCopyByEmailModal && <SendPayerCopyByEmailModal
                isPopupOpen={sendPayerCopyByEmailModal}
                options={federalForms}
                onSubmitCb={(selectedForm) => dispatch(sendPayerCopyInMail({ payerId: federalStates.FederalPayer.value, taxYear: federalStates.FederalTaxYear.value, formName: selectedForm?.value }))}
                onCloseCb={() => dispatch(setSendPayerCopyEmailModal(false))}
            />}

            {/* Download pdf for a single row */}
            <DownloadPdf
                isPopupOpen={downloadSingleRowPDFModal}
                onCloseCb={() => {
                    dispatch(setDownloadSingleRowPDFModal(false));
                    dispatch(setDownloadPdfSelectedSelectedStates({ name: "Forms", value: { value: "", label: "" } }));
                    dispatch(setDownloadPdfSelectedSelectedStates({ name: "Reference", value: { value: "", label: "" } }));
                }}
                onChangeRadioCb={(event) => dispatch(setDownloadPdfType(event.target.name))}
                downloadPdfType={downloadPdfType}
                onSubmitCb={() => {
                    if (downloadPdfType.length !== 0) {
                        dispatch(getFederalPDF({ payerId: federalStates.FederalPayer.value, formId: federalFormData?.EncryptedFormId, formTypeId: federalFormData?.FormTypeId, pdfAction: downloadPdfType, mergeCopies: downloadPdfCheckboxStates.mergeCopies, UnmaskTin: IsTinUnmaskAllowed ? !isTINHidden : false }))
                    } else {
                        dispatch(addNotifications({ heading: "Error", message: "Please the copy that you want!" }))
                    }
                }}
                checkboxValues={downloadPdfCheckboxStates}
                onChangeCheckBoxCb={onChangeDownloadPdfCheckboxCb}
            />


            {/* Download Multiple PDF modal */}
            {downloadMultiplePDFModal &&
                <DownloadPdf
                    downloadPdfByForm={true}
                    isPopupOpen={downloadMultiplePDFModal}
                    onCloseCb={() => {
                        dispatch(setDownloadMultiplePDFModal(false));
                        dispatch(setDownloadPdfSelectedSelectedStates({ name: "Forms", value: { value: "", label: "" } }));
                        dispatch(setDownloadPdfSelectedSelectedStates({ name: "Reference", value: { value: "", label: "" } }));
                    }}
                    federalForms={downloadPdfOptions}
                    onSelectOptionsCb={(name, selectedOption) => dispatch(setDownloadPdfSelectedSelectedStates({ name, value: selectedOption }))}
                    downloadPdfStates={downloadPdfStates}
                    onChangeRadioCb={(event) => dispatch(setDownloadPdfType(event.target.name))}
                    downloadPdfType={downloadPdfType}
                    onSubmitCb={() => {
                        if (downloadPdfStates.Forms.label.length !== 0 && downloadPdfType.length !== 0) {
                            dispatch(downloadFedMultiplePDFs({ payerId: federalStates?.FederalPayer?.value, formName: downloadPdfStates?.Forms?.label, payerName: federalStates?.FederalPayer?.label, taxYear: federalStates?.FederalTaxYear?.value, pdfCopy: downloadPdfType, maskTin: federalStates?.FederalPayer?.UnmaskTin, FormIds: selectedFederalForms.map(item => item?.EncryptedFormId).toString(), referenceNo: selectedFederalForms.map(form => form?.EncryptedReferenceNumber).toString(), mergeCopies: downloadPdfCheckboxStates?.mergeCopies }))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select form and copy you want!" }))
                        }
                    }}
                    checkboxValues={downloadPdfCheckboxStates}
                    onChangeCheckBoxCb={onChangeDownloadPdfCheckboxCb}
                />
            }

            {/* Download PDF's For Selected Payers */}
            {downloadPDFsForSelectedPayerModal &&
                <DownloadPdf
                    downloadPdfByPayerAndForm={true}
                    isPopupOpen={downloadPDFsForSelectedPayerModal}
                    onCloseCb={() => {
                        dispatch(setDownloadPDFsForSelectedPayerModal(false));
                        dispatch(setDownloadPdfSelectedSelectedStates({ name: "Forms", value: { value: "", label: "" } }));
                        dispatch(setDownloadPdfSelectedSelectedStates({ name: "Reference", value: { value: "", label: "" } }));
                    }}
                    federalPayers={federalPayers}
                    federalForms={federalForms}
                    downloadPdfStates={downloadPdfStates}
                    downloadPdfType={downloadPdfType}
                    onChangeRadioCb={(event) => dispatch(setDownloadPdfType(event.target.name))}
                    onSelectMultipleOptionsCb={(selectedOption) => dispatch(setSelectMultiplePayers(selectedOption))}
                    onSelectOptionsCb={(name, selectedOption) => dispatch(setDownloadPdfSelectedSelectedStates({ name, value: selectedOption }))}
                    onSubmitCb={() => {
                        if (downloadPdfStates.Forms.label.length && downloadPdfType.length && multipleSelectedPayer.length) {
                            dispatch(downloadFedPDFsByPayers({ payerId: multipleSelectedPayer?.map(payer => payer.value)?.toString() || "", formName: downloadPdfStates.Forms.label, payerName: multipleSelectedPayer?.map(payer => payer.label)?.toString() || "", taxYear: federalStates.FederalTaxYear.value, pdfCopy: downloadPdfType, maskTin: IsTinUnmaskAllowed ? isTINHidden : false, partNumber: "", mergeCopies: downloadPdfCheckboxStates.mergeCopies }))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select form, payers and copy you want!" }))
                        }
                    }}
                    checkboxValues={downloadPdfCheckboxStates}
                    onChangeCheckBoxCb={onChangeDownloadPdfCheckboxCb}
                />
            }

            {/* Download PDF By Reference Number */}
            <DownloadPdf
                downloadPdfByReference={true}
                isPopupOpen={downloadPDFsByReferenceModal}
                onCloseCb={() => {
                    dispatch(setDownloadPDFsByReferenceModal(false));
                    dispatch(setDownloadPdfSelectedSelectedStates({ name: "Forms", value: { value: "", label: "" } }));
                    dispatch(setDownloadPdfSelectedSelectedStates({ name: "Reference", value: { value: "", label: "" } }));
                }}
                referenceNumber={referenceNumber}
                onSelectOptionsCb={(name, selectedOption) => dispatch(setDownloadPdfSelectedSelectedStates({ name, value: selectedOption }))}
                downloadPdfStates={downloadPdfStates}
                downloadPdfType={downloadPdfType}
                onChangeRadioCb={(event) => dispatch(setDownloadPdfType(event.target.name))}
                onSubmitCb={() => {
                    const referenceLabel = downloadPdfStates?.Reference?.label;
                    const selectedPdfType = downloadPdfType.length > 0;
                    if (referenceLabel?.length && selectedPdfType) {
                        const filteredForm = federalGridForms.filter(item => item?.ReferenceNumber === referenceLabel)[0];
                        if (filteredForm) {
                            const formId = filteredForm?.FormId;
                            dispatch(downloadFedPDFsByReference({
                                payerId: federalStates?.FederalPayer?.value,
                                payerName: federalStates?.FederalPayer?.label,
                                taxYear: federalStates?.FederalTaxYear?.value,
                                pdfCopy: downloadPdfType,
                                maskTin: federalStates?.FederalPayer?.UnmaskTin,
                                referenceNo: downloadPdfStates?.Reference?.EncryptedReferenceNumber,
                                formId: formId,
                                mergeCopies: downloadPdfCheckboxStates?.mergeCopies
                            }));
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Form not found for the selected reference number!" }));
                        }
                    } else {
                        dispatch(addNotifications({ heading: "Error", message: "Please select reference number and copy you want!" }));
                    }
                }}
                checkboxValues={downloadPdfCheckboxStates}
                onChangeCheckBoxCb={onChangeDownloadPdfCheckboxCb}
            />

            <EDeliveryModal
                isOpen={eDeliveryModal}
                onCancelCb={() => dispatch(setEDeliveryModalOpen(false))}
                selectedForms={selectedFederalForms}
                payerDetails={federalStates?.FederalPayer}
            />

            {exportToExcelModal && <ExportToExcel
                isPopupOpen={exportToExcelModal}
                title={"Export to Excel"}
                onCloseCb={() => dispatch(setExportToExcelModal(false))}
                federalForms={downloadPdfOptions}
                onSelectFormCb={(name, selectedOption) => dispatch(setExportToExcelSelectedForm({ name, value: selectedOption }))}
                onSubmitCb={() => dispatch(getFederalExport({ payerId: federalStates.FederalPayer.value, formId: exportToExcelStates.Form.FormId, taxYear: federalStates.FederalTaxYear.value, formName: exportToExcelStates.Form.label }))}
                exportToExcelStates={exportToExcelStates}
            />}

            {exportToExcelForSelectedPayersModal && <ExportToExcel
                exportToExcelBySelectedPayers={true}
                isPopupOpen={exportToExcelForSelectedPayersModal}
                title={"Export to Excel for Selected Payers"}
                federalForms={federalForms}
                federalPayers={federalPayers}
                onCloseCb={() => dispatch(setExportToExcelForSelectedPayersModal(false))}
                exportToExcelStates={exportToExcelStates}
                onSelectFormCb={(name, selectedOption) => dispatch(setExportToExcelSelectedForm({ name, value: selectedOption }))}
                onSelectOptionsCb={(selectedOptions) => dispatch(setSelectedPayers(selectedOptions))}
                onSubmitCb={() => dispatch(getFederalExportForSelectedPayer({ payerIds: selectedPayers.map(item => item.value).toString(), formId: exportToExcelStates.Form.FormId, taxYear: federalStates.FederalTaxYear.value, formName: exportToExcelStates.Form.label }))}
            />}

            {exportToExcelForAllPayers && <ExportToExcel
                isPopupOpen={exportToExcelForAllPayers}
                title={"Export to Excel for All Payers"}
                exportToExcelAllPayers={true}
                onCloseCb={() => dispatch(setExportToExcelForAllPayers(false))}
                onSelectFormCb={(name, selectedOption) => dispatch(setExportToExcelSelectedForm({ name, value: selectedOption }))}
                onSubmitCb={() => dispatch(getFederalExportForAllPayers({ formId: exportToExcelStates.Form.FormId, taxYear: exportToExcelStates.TaxYear.label, formName: exportToExcelStates.Form.label }))}
                federalForms={federalForms}
                federalTaxYear={federalTaxYear}
                exportToExcelStates={exportToExcelStates}
            />}


            <USPSMailToRecipients
                isOpen={uspsMailToRecipientsModal}
                onCancelCb={() => dispatch(setUspsMailToRecipientsModal(false))}
                selectedForms={selectedFederalForms}
                payerDetails={federalStates?.FederalPayer}
                taxYear={federalStates.FederalTaxYear}
            />

            {blockFederalFormModal && <ConfirmationPopup title='Are you sure?'
                bodyText={`Are you sure you want to block this recipient's form for submission? This will delete the form as well and this action cannot be undone.`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={blockFederalFormModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(blockFederalSubmission({ referenceNumber: federalFormData?.ReferenceNumber, State: federalFormData?.state1, formId: federalFormData?.FormId, formTypeId: federalFormData?.FormTypeId }))
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setBlockFederalFormModal(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />}

            {
                changeScheduleDateForAllVendor &&
                <ChangeScheduleDateModal
                    title="Change Schedule Date"
                    inputLabel="Select a date"
                    isOpen={changeScheduleDateForAllVendor}
                    formName={selectedFederalForms[0].FormName}
                    onCloseCb={() => dispatch(setChangeScheduleDate(!changeScheduleDateForAllVendor))}
                    onSubmitCb={(scheduleDate) => dispatch(changeScheduleData({ scheduleDate, selectedFederalForms, payerId: federalStates?.FederalPayer?.value, taxYear: federalStates?.FederalTaxYear?.value, paginationState }))}
                />
            }

            {stateFilingModal &&
                <StateFiling
                    isOpen={stateFilingModal}
                    onCloseCb={() => {
                        dispatch(setStateFilingModal(false))
                        dispatch(getFederalGridData({ payerId: federalStates.FederalPayer.value, taxYear: federalStates.FederalTaxYear.value, FilterText: paginationState.FilterText, PageNumber: paginationState.PageNumber, PageSize: paginationState.PageSize, IsDesc: paginationState.IsDesc }));
                    }}
                    selectedRows={selectedFederalForms}
                    gridData={federalGridForms}
                />
            }


            {bulkStateFilingModal && <BulkStateFiling
                isOpen={bulkStateFilingModal}
                onCloseCb={() => dispatch(setBulkStateFilingModal(false))}
                formOptions={stateForms}
                payerId={federalStates?.FederalPayer?.value}
                taxYear={federalStates?.FederalTaxYear?.value}
            />}

        </>
    )

    const handleSendCopyByEmail = () => {
        dispatch(setManageFormsLoad(mergeObjectsByFormName(federal94XGridForms)))
        dispatch(setSendPayerCopyByEmail94xModal(true))
    }

    const Body2 = (
        <div>
            <div style={commonStyles.selectDropdown}>
                <SelectDropdown
                    label="Employer *"
                    name="FederalPayer2"
                    placeHolder="Please select a employer"
                    options={federalPayers}
                    onSelectCb={(name, selectedOption) => {
                        dispatch(setSelectedFederalStates({ name: [name], value: selectedOption }));

                        if (selectedOption?.value) {
                            queryParams.set("PayerId", selectedOption?.value)
                        } else {
                            queryParams.delete("PayerId")
                        }
                        setQueryParams(queryParams);
                        dispatch(setSelectedFederal91xForms([]))
                        dispatch(setPaginationState94x({ PageNumber: 1, Skip: 0 }));
                    }}
                    value={federalStates.FederalPayer2}
                />

                <Loadable currentState={loadingState.state} loadingStates={[MANAGE_FEDERAL_FORMS_LOADING_STATES.TAX_YEARS_LOADING]} messageMap={MANAGE_FEDERAL_FORMS_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                    <SelectDropdown
                        name="FederalTaxYear2"
                        label="Tax Year *"
                        placeHolder="Please select tax year"
                        onSelectCb={(name, selectedOption) => {
                            dispatch(setSelectedFederalStates({ name: [name], value: selectedOption }));

                            if (selectedOption?.value) {
                                queryParams.set("TaxYear", selectedOption?.value)
                            } else {
                                queryParams.delete("TaxYear")
                            }
                            setQueryParams(queryParams);
                            dispatch(setSelectedFederal91xForms([]))
                            dispatch(setPaginationState94x({ PageNumber: 1, Skip: 0 }));
                        }}
                        options={federal94xTaxYear}
                        value={federalStates.FederalTaxYear2}
                    />
                </Loadable>
            </div>

            <div style={commonStyles.buttonContainer}>
                <Button style={commonStyles.button}
                    onClickCb={() => {
                        if (federalStates.FederalPayer2.value.length !== 0 && federalStates.FederalTaxYear2.value.length !== 0 && selectedFederal91xForms.length !== 0) {
                            dispatch(setManageFormsLoad(mergeObjectsByFormName(selectedFederal91xForms)))
                            dispatch(setDownload94xMultiplePdfModal(true))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select employer, tax year and forms." }))
                        }
                    }}
                >Download Multiple PDFs</Button>
                <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={commonStyles.button} onClickCb={handleSendCopyByEmail}>Send Copy by Email</Button>
            </div>

            <Loadable currentState={loadingState.state} loadingStates={[MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_LOADING]} messageMap={MANAGE_FEDERAL_FORMS_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                <div>
                    <RichGrid
                        selectable={true}
                        data={federal94XGridForms}
                        columns={MANAGE_FEDERAL_FORM_COLUMN_2}
                        extractRowKey={(row) => row.FormId}
                        selectedRows={selectedFederal91xForms}
                        onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedFederal91xForms(selectedData))}
                        onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedFederal91xForms(selectedData))}
                        paginationProps={{
                            skip: paginationState94x?.Skip,
                            take: paginationState94x?.PageSize,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            total: paginationState94x?.Total,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setPaginationState94x({ PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            },
                            onChange: (take, skip) => {
                                dispatch(setPaginationState94x({ PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            }
                        }}
                    />
                </div>
            </Loadable>


            {/* Download 94x Multiple PDF modal */}
            {download94xMultiplePdfModal &&
                <DownloadPdf
                    isPdfType={false}
                    downloadPdfByForm={true}
                    isPopupOpen={download94xMultiplePdfModal}
                    onCloseCb={() => {
                        dispatch(setDownload94xMultiplePdfModal(false));
                        dispatch(setDownloadPdfSelectedSelectedStates({ name: "Forms", value: { value: "", label: "" } }));
                        dispatch(setDownloadPdfSelectedSelectedStates({ name: "Reference", value: { value: "", label: "" } }));
                    }}
                    federalForms={manageFormsLoad}
                    onSelectOptionsCb={(name, selectedOption) => dispatch(setDownloadPdfSelectedSelectedStates({ name, value: selectedOption }))}
                    downloadPdfStates={downloadPdfStates}
                    onChangeRadioCb={(event) => dispatch(setDownloadPdfType(event.target.name))}
                    downloadPdfType={downloadPdfType}
                    onSubmitCb={() => {
                        if (downloadPdfStates.Forms.label.length) {
                            dispatch(downLoad94xPDFs({ payerId: federalStates.FederalPayer2.value, formIds: selectedFederal91xForms.filter(item => item.FormName === downloadPdfStates.Forms.label).map(item => item.FormId).toString(), formName: downloadPdfStates.Forms.label, payerName: federalStates.FederalPayer2.label, referenceNo: selectedFederal91xForms.map(item => item.ReferenceNumber).toString(), taxYear: federalStates.FederalTaxYear2.label, maskTin: IsTinUnmaskAllowed ? isTINHidden : false }))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "Please select form to continue!" }))
                        }
                    }}
                />
            }

            {sendPayerCopyByEmail94xModal && <SendPayerCopyByEmailModal
                isPopupOpen={sendPayerCopyByEmail94xModal}
                onSubmitCb={(selectedForm) => dispatch(sendPayerCopyInMail({ payerId: federalStates.FederalPayer2.value, taxYear: federalStates.FederalTaxYear2.value, formName: selectedForm?.label }))}
                onCloseCb={() => dispatch(setSendPayerCopyByEmail94xModal(false))}
                options={manageFormsLoad}
            />}
        </div>
    )

    return (
        <div>
            <Accordion header={'Form 1099/W-2/W-2VI/W-2GU/W-2G/1095/1098/3921/3922/480'} body={Body1} active={accordionOpen} onClickCb={() => dispatch(toggle(!accordionOpen))} />
            <Accordion header={'Form 940/941/943/944/945/941x/941PR/1042/8027/944x'} body={Body2} active={!accordionOpen} onClickCb={() => dispatch(toggle(!accordionOpen))} />
            <InformationPopup
                title={"Please Note"}
                bodyText={warningPopupMessage}
                isOpen={warningPopupMessage?.length > 0}
                confirmationButtonProps={{
                    onConfirmationCb: () => setWarningPopupMessage(""),
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                showClose={false}
                customBodyContainerStyle={commonStyles.errorPopupBodyContainer}
            >
                <div style={commonStyles.downloadErrorsBtnContainer}>
                    <Button style={commonStyles.button} type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={onDownloadErrorsClick}>
                        Download Errors
                    </Button>
                </div>
            </InformationPopup>
        </div>
    )
}

export default ManageFederalForms
